import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayUnUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayUnUseRequestDTO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly data: RoomBrandOverlayUnUseRequest) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayUnUseRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      }
    };
  }
}

interface RoomBrandOverlayUnUseRequest {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
